<template>
  <div class="set-auth">
    <div class="auth-content">
      <n-spin size="large">
        <template #description>
          权限验证中...
        </template>
      </n-spin>
    </div>
  </div>
</template>

<script>
import { UnionAuth } from 'unionauth'
import http from '@/service/http.ts'
import axios from 'axios'
import JSEncrypt from 'jsencrypt'
import { router } from '@/router/router'
export default {
  data() {
    return {
      token: '',
      accessToken: '',
      authUrl: 'http://23.210.52.92:8799',
      userName: 21,
      appKey: '29c2324b46bcbf8b8d6ff3f34758ffd3',
      secret: '7eefda395ebfe726860208858fd5a006b2882add5a36b1e7d5a02a6eb154e0d0b91838ff16614514cbc938d17a969bb4',
      headers: {
        'Content-Type': 'application/json',
        'request-id': 'cbf8b8d6cbf8b8d6cbf8b8d6cbf8b8d6',
        'app-key': '29c2324b46bcbf8b8d6ff3f34758ffd3',
      }
    }
  },
  mounted() {
    this.setAuth()
  },
  methods: {
    // 初始化sdk并获取token
    setAuth() {
      console.log('------start------')
      const unionAuth = new UnionAuth({
        appKey: this.appKey
      })
      // unionAuth.ready().then((res) => {
      //   console.log('res=====>', res)
      //   this.token = unionAuth.getToken()
      //   // this.setAccess()
      //   if (this.token) {
      //     this.setLogin()
      //   } else {
      //     router.push('/login')
      //   }
      // })
      unionAuth.ready()
      this.token = unionAuth.getToken()
      if (this.token) {
        this.setLogin()
      } else {
        router.push('/login')
      }
    },
    // 获取accessToken
    setAccess() {
      axios({
        method: 'get',
        url: `${this.authUrl}/union-auth/third-api/access-token?secret=${this.secret}`,
        headers: this.headers
      }).then(res => {
        console.log('res======>', res)
      }).catcha(err => {
        console.log('err======>', err)
      })
    },
    // 获取角色信息
    async setRole() {
      const params = {
        token: this.token,
        accessToken: this.accessToken
      }
    },
    // 获取渝快政id
    async setAccountId() {
      const params = {
        token: this.token,
        accessToken: this.accessToken
      }
    },
    // 验证通过就进入系统，不通过就跳到登录页
    setLogin() {
      http
        .get(`${process.env.VUE_APP_BASE_URL}api/sso/RSA/getPublicKey?loginName=admin`)
        .then((res) => {
          if (res.data.msg && res.data.code === 200) {
            const rsaPass = this.doEncryptor(res.data.msg, 'HTwl123!')
            http
              .post(`${process.env.VUE_APP_BASE_URL}api/sso/auth/login`, {
                password: rsaPass,
                username: 'admin',
              })
              .then((loginRes) => {
                if (loginRes.data.data) {
                  sessionStorage.setItem('token', loginRes.data.data.access_token)
                  router.push('/main')
                } else {
                  this.$message({
                    message: loginRes.data.msg,
                    type: 'error'
                  });
                }
              })
              .catch((e) => {
                console.log(e, '登录错误')
              })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
            console.log(res.data, '错误异常')
          }
        })
        .catch((err) => {
          console.log(err, '---------获取公钥失败。')
        })
    },
    // 验证通过时获取加密密码
    doEncryptor(pub, psd) {
      let encriptor = new JSEncrypt()
      encriptor.setPublicKey(pub)
      return encriptor.encrypt(psd)
    },
  }
}
</script>

<style lang="scss">
  .set-auth {
    width: 100%;
    height: 100%;
    .auth-content {
      width: 40px;
      margin: 30vh auto;
    }
  }
</style>